import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import * as _ from 'lodash';
import { AppSessionService } from '../app-session/app-session.service';

// const DATA_URL = 'http://192.168.1.35:51024/api/v1/categories/elements?usageCode=CUSTOMER';
// const DATA_URL = 'http://192.168.1.35:51024/api/v1/categories/elements';


@Injectable({
  providedIn: 'root'
})
export class LoggerService {

  public remoteData: BehaviorSubject<any[]>;
  private BASE_URL = this.appSession.baseUrl + '/api/v1/menu';


  constructor(
    private http: HttpClient,
    private appSession: AppSessionService
    ) {

    this.remoteData = new BehaviorSubject([]);
  }


  createErrorLog(logger: any): Observable<any>{
    const headers = new HttpHeaders({
      'Content-type': 'application/json'
    });

    const data = JSON.stringify(logger);
    const url = 'https://hookb.in/aBeRdjmaD2c1oobLKxOx' //`${this.appSession.baseUrl + '/api/v1/contractMovements/updateContractMovement'}`;
    return this.http.post(url, data, { headers });
  }


}
